import React from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { Facility } from 'src/modules/common/types';

interface Props {
  facilities: Facility[] | undefined;
  selected: Facility | undefined;
  onSelect: (value: string) => void;
}

const FacilityList = ({ facilities, onSelect, selected }: Props) => {
  return (
    <Select
      sx={{
        marginBottom: 2,
        '&.MuiInputBase-root': {
          width: '100%',
        },
      }}
      id="facility-select"
      name="facility"
      value={selected ? selected.id : ''}
      IconComponent={KeyboardArrowDownIcon}
      onChange={(e: SelectChangeEvent) => onSelect(e.target.value)}
    >
      {facilities?.map(facility => (
        <MenuItem key={facility.id} value={facility.id}>
          {facility.name} - {facility.city}
        </MenuItem>
      ))}
    </Select>
  );
};

export default FacilityList;
